module.exports = __webpack_public_path__ + "img/lead-10e.fe0b6c60.png";